<template>
  <div class="modal">
    <div class="modal-header__container">
      <div class="modal__header">
        <p class="modal__action">
          {{ editId ? $t('Edit tender') : $t('Create tender') }} ·
          {{ projectTitle }}
        </p>
        <h2 class="modal__title">
          {{ title }}
        </h2>
        <button class="modal__close-button" @click="handleClose">
          <CloseIcon class="close-button__icon" />
        </button>
      </div>
      <div class="hr" />
    </div>
    <slot name="form" />
    <div v-if="!$slots.form" class="d-contents">
      <div class="modal-content__container">
        <slot />
      </div>
      <div class="modal-navigation__container">
        <div class="hr" />
        <div class="modal__navigation">
          <ProgressSteps
            :current="currentStep"
            class="navigation__steps"
            :steps="TENDER_EDIT_STEPS"
            @go-to-step="$emit('change-step', $event)"
          />

          <div class="navigation__buttons">
            <slot name="buttons" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex';
  import CloseIcon from '@/assets/icons/x.svg';
  import ProgressSteps from '@/components/ui/ProgressSteps';
  import TENDER_EDIT_STEPS from '@/utils/constants/tender-edit-steps';

  export default {
    name: 'CreateBase',
    components: {
      CloseIcon,
      ProgressSteps,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      currentStep: {
        type: Number,
        default: 1,
      },
    },
    data() {
      return {
        TENDER_EDIT_STEPS,
      };
    },
    methods: {
      ...mapActions({
        setModalAction: 'modal/setModalAction',
        close: 'modal/closeModal',
      }),
      handleClose() {
        this.$emit('close');
      },
    },
    computed: {
      ...mapGetters('tenderEdit', ['editId']),
      ...mapState('project', ['projectInfo']),
      projectTitle() {
        return this.projectInfo?.name || '';
      },
    },
  };
</script>
